import { useTranslation } from 'next-i18next';
import type { DeliveryOption } from '../../../codegen/types';
import { useFeatureFlagsContext } from '../../../context/featureFlagsContext';
import { useStar2 } from '../../../hooks/useStar2';
import { renderDeliveryOptionsTranslation } from '../../../utils';
import { capitalizeFirstLetter } from '../../../utils/capitalizeFirstLetter';
import { RenderPrice } from '../taxAndTotals/CartDelivery';
import {
  DeliveryDays,
  DeliveryItem,
  DeliveryName,
  DeliveryOptionsWrapper,
  NoDeliveryOptions,
} from './DeliveryOptionsList.styles';

export function DeliveryOptionsList({ deliveryOptions }: { deliveryOptions: DeliveryOption[] | undefined }) {
  const { t } = useTranslation(['lib-global-common']);
  const { isAdyenCheckoutEnabled } = useFeatureFlagsContext();
  const { isStar2 } = useStar2();

  if (!deliveryOptions?.length) return <NoDeliveryOptions>{t('cart.delivery.and.returns.error')}</NoDeliveryOptions>;

  return (
    <DeliveryOptionsWrapper>
      {deliveryOptions?.map(({ currency, deliveryTime, price, name, key: deliveryKey }) => (
        <DeliveryItem key={deliveryKey}>
          <RenderPrice price={price} currency={currency} />{' '}
          <DeliveryName data-testid="deliveryName">
            {isStar2 && !isAdyenCheckoutEnabled ? renderDeliveryOptionsTranslation(deliveryKey, t, name) : name}
          </DeliveryName>{' '}
          <DeliveryDays data-testid="deliveryDays">
            {isStar2 && !isAdyenCheckoutEnabled
              ? t('cart.delivery.and.returns.deliveryTime', { deliveryTime })
              : capitalizeFirstLetter(deliveryTime)}
          </DeliveryDays>
        </DeliveryItem>
      ))}
    </DeliveryOptionsWrapper>
  );
}
